<template>
  <transition name="modal-body">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-800">
          <div class="modal-header">
            <slot name="header"> New Topping </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-2">
                  <label for="topping"> Description: </label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="description"
                    ref="topping_description"
                    placeholder="Enter topping description"
                    v-modal="topping_description"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-2">
                  <label for="topping"> Colour: </label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="colour"
                    ref="topping_colour"
                    placeholder="enter topping colour"
                    v-modal="topping_colour"
                  />
                </div>
              </div>

            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
          
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CreateTopping",

  // DATA
  data: () => ({
    topping_description: "",
    topping_colour: "",
  }),

  // METHODS
  methods: {
    //...mapActions("inventory", ["apiCreatePlantBotany"]), // inventory.js
    ...mapActions("inventory", ["apiCreateTopping"]),

    _save() {
      if (!this.$refs.topping_description.value) {
        alert("please enter a topping description"); // todo - place the correct references
        return;
      }

      // TODO - Create a variable for the data
      var item = {
        id: 0,
        active: true,
        topping_description: this.$refs.topping_description.value,
        topping_colour: this.$refs.topping_colour.value,
      };

      this.apiCreateTopping(item);
      this.$emit("close");
    },

    // TODO -
    getToppingDescription() {
      if (this.inventory == null) {
        return "";
      } else {
        return this.topping_description;
      }
    },

    clear() {
      this.topping_description = "";
      this.topping_colour = "";
    },
  },

  // COMPONENTS
  components: {},
};
</script>
